import React from 'react';
import { icons } from 'assets/icons.json';

function Icon(props) {
  const icon = icons.find((x) => x.name === props.icon);
  return <div dangerouslySetInnerHTML={{ __html: icon.content }} />;
}

export default Icon;
